
import axios from '../wmsAxios'

/*
 * 机构管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/tWaveMaster/save',
        method: 'post',
        data
    })
}

// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/tWaveMaster/delete',
        method: 'post',
        data
    })
}

// 查询分页数据
export const findPage = (data) => {
    return axios({
        url: '/tWaveMaster/findPage',
        method: 'post',
      data
    })
}

// 释放波次
export const releaseWave = (data) => {
  return axios({
    url: '/tWaveMaster/releaseWave',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/tWaveMaster.js